/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ItemCalculationFragmentDoc, WithDocumentItemTaskInfoFragmentDoc, WithItemPropertiesFragmentDoc, WithProductInfoFragmentDoc, WithDocumentItemCalculationFragmentDoc, DocumentItem_CalculationsFragmentDoc, WithProductFiltersInfoFragmentDoc, FieldsAffectedByAttributeExpressionsFragmentDoc, TreeItem__DocumentItemFragmentDoc, TreeItemTemplatePlaceholderFragmentDoc, WithDocumentItemInfoFragmentDoc, WithDocumentItemTreeInfoFragmentDoc, WithDocumentItemVisibilityInfoFragmentDoc, WithDocumentItemChangeOrderInfoFragmentDoc, WithDocumentItemAgreementInfoFragmentDoc, WithDocumentItemDecisionInfoFragmentDoc, ItemProductFieldsFragmentDoc } from '../Fragments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ItemAttributesOverrideModal_ItemFragment = { __typename: 'Item', id: string, type: Types.ItemType, isRootItem: boolean, originVersionNumber?: number | null, title: string, description: string, itemAttributeOverrides: Array<{ __typename: 'ItemAttributeOverride', attribute: Types.ItemAttributeOverridesAttributeName, valueAsJson?: string | null }>, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type DefineItemAttributeOverridesMutationVariables = Types.Exact<{
  input: Types.DefineItemAttributeOverridesInput;
}>;


export type DefineItemAttributeOverridesMutation = { defineItemAttributeOverrides: boolean };

export type ItemAttributesOverrideModalQueryVariables = Types.Exact<{
  docId: Types.Scalars['ID']['input'];
  itemId: Types.Scalars['ID']['input'];
  versionNumber: Types.Scalars['Int']['input'];
  applyOverrides: Types.Scalars['Boolean']['input'];
}>;


export type ItemAttributesOverrideModalQuery = { quoteTemplateVersion: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateVersionResult', quoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, item: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, type: Types.ItemType, isRootItem: boolean, title: string, description: string, itemAttributeOverrides: Array<{ __typename: 'ItemAttributeOverride', attribute: Types.ItemAttributeOverridesAttributeName, valueAsJson?: string | null }>, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> } | null } };

export const ItemAttributesOverrideModal_ItemFragmentDoc = gql`
    fragment ItemAttributesOverrideModal_Item on Item {
  id
  type
  isRootItem
  originVersionNumber
  itemAttributeOverrides {
    attribute
    valueAsJson
  }
  title
  description
  proposedCalculation {
    ...ItemCalculation
  }
}
    ${ItemCalculationFragmentDoc}`;
export const DefineItemAttributeOverridesDocument = gql`
    mutation defineItemAttributeOverrides($input: DefineItemAttributeOverridesInput!) {
  defineItemAttributeOverrides(input: $input)
}
    `;
export type DefineItemAttributeOverridesMutationFn = Apollo.MutationFunction<DefineItemAttributeOverridesMutation, DefineItemAttributeOverridesMutationVariables>;

/**
 * __useDefineItemAttributeOverridesMutation__
 *
 * To run a mutation, you first call `useDefineItemAttributeOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineItemAttributeOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineItemAttributeOverridesMutation, { data, loading, error }] = useDefineItemAttributeOverridesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefineItemAttributeOverridesMutation(baseOptions?: Apollo.MutationHookOptions<DefineItemAttributeOverridesMutation, DefineItemAttributeOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DefineItemAttributeOverridesMutation, DefineItemAttributeOverridesMutationVariables>(DefineItemAttributeOverridesDocument, options);
      }
export type DefineItemAttributeOverridesMutationHookResult = ReturnType<typeof useDefineItemAttributeOverridesMutation>;
export type DefineItemAttributeOverridesMutationResult = Apollo.MutationResult<DefineItemAttributeOverridesMutation>;
export type DefineItemAttributeOverridesMutationOptions = Apollo.BaseMutationOptions<DefineItemAttributeOverridesMutation, DefineItemAttributeOverridesMutationVariables>;
export const ItemAttributesOverrideModalDocument = gql`
    query ItemAttributesOverrideModal($docId: ID!, $itemId: ID!, $versionNumber: Int!, $applyOverrides: Boolean!) {
  quoteTemplateVersion(
    id: $docId
    versionNumber: $versionNumber
    applyOverrides: $applyOverrides
  ) {
    ... on QuoteTemplateVersionResult {
      quoteTemplate {
        id
        resolvedAsReadModelVersionNumber
        owningSystemOrganisationId
        item: items(itemId: $itemId) {
          id
          originVersionNumber
          ...ItemAttributesOverrideModal_Item
        }
      }
    }
  }
}
    ${ItemAttributesOverrideModal_ItemFragmentDoc}`;

/**
 * __useItemAttributesOverrideModalQuery__
 *
 * To run a query within a React component, call `useItemAttributesOverrideModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemAttributesOverrideModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemAttributesOverrideModalQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      itemId: // value for 'itemId'
 *      versionNumber: // value for 'versionNumber'
 *      applyOverrides: // value for 'applyOverrides'
 *   },
 * });
 */
export function useItemAttributesOverrideModalQuery(baseOptions: Apollo.QueryHookOptions<ItemAttributesOverrideModalQuery, ItemAttributesOverrideModalQueryVariables> & ({ variables: ItemAttributesOverrideModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemAttributesOverrideModalQuery, ItemAttributesOverrideModalQueryVariables>(ItemAttributesOverrideModalDocument, options);
      }
export function useItemAttributesOverrideModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemAttributesOverrideModalQuery, ItemAttributesOverrideModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemAttributesOverrideModalQuery, ItemAttributesOverrideModalQueryVariables>(ItemAttributesOverrideModalDocument, options);
        }
export function useItemAttributesOverrideModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ItemAttributesOverrideModalQuery, ItemAttributesOverrideModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ItemAttributesOverrideModalQuery, ItemAttributesOverrideModalQueryVariables>(ItemAttributesOverrideModalDocument, options);
        }
export type ItemAttributesOverrideModalQueryHookResult = ReturnType<typeof useItemAttributesOverrideModalQuery>;
export type ItemAttributesOverrideModalLazyQueryHookResult = ReturnType<typeof useItemAttributesOverrideModalLazyQuery>;
export type ItemAttributesOverrideModalSuspenseQueryHookResult = ReturnType<typeof useItemAttributesOverrideModalSuspenseQuery>;
export type ItemAttributesOverrideModalQueryResult = Apollo.QueryResult<ItemAttributesOverrideModalQuery, ItemAttributesOverrideModalQueryVariables>;